import axios from 'axios';
import { toast } from 'sonner';

const API_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Track a gamification event (idempotent on the server side).
 * Awards XP, unlocks the matching badge and updates the streak.
 * Shows a toast for newly-awarded badges.
 *
 * Usage: await trackEvent(token, 'first_letter');
 */
export const trackEvent = async (token, event) => {
  if (!token || !event) return null;
  try {
    const { data } = await axios.post(
      `${API_URL}/api/gamification/track`,
      { event },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (data?.newly_awarded?.length) {
      data.newly_awarded.forEach((badge) => {
        toast.success(`Badge débloqué : ${badge.name}`, {
          description: `+${badge.xp} XP — ${badge.description}`,
          duration: 5000,
        });
      });
    }
    return data;
  } catch (_e) {
    // Silent: gamification must never block the main flow
    return null;
  }
};
